(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["IVR-COMBO2PRODUTO"] && !Shopify.designMode) return;
  try {
    
 (() => {
    const ROOT_SELECTOR = '[data-ivory-bundle]';
    const CART_DRAWER_RELOAD_FLAG = 'ivoryBundleOpenCartDrawerAfterReload';
    const CART_DRAWER_RELOAD_PARAM = 'open_cart_drawer';

    const escapeHtml = (value) => String(value ?? '')
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');

    const formatMoney = (cents) => {
      const currency = window.Shopify?.currency?.active || 'BRL';
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'pt-BR', {
          style: 'currency',
          currency
        }).format((Number(cents) || 0) / 100);
      } catch (error) {
        return `R$ ${((Number(cents) || 0) / 100).toFixed(2).replace('.', ',')}`;
      }
    };

    const parseProduct = (id) => {
      const source = document.getElementById(id);
      if (!source) return null;
      try { return JSON.parse(source.textContent); } catch (error) { return null; }
    };

    const getVariant = (card) => {
      const select = card.querySelector('[data-variant-select]');
      const single = card.querySelector('[data-single-variant]');
      const source = select && !select.hidden ? select.selectedOptions[0] : single;
      const id = select && !select.hidden ? select.value : single?.value;
      if (!source || !id) return null;
      return {
        id: Number(id),
        title: source.dataset.title || '',
        price: Number(source.dataset.price) || 0,
        compare: Number(source.dataset.compare) || 0,
        image: source.dataset.image || '',
        available: source.dataset.available !== 'false' && !source.disabled
      };
    };

    const displayPrice = (card, variant) => {
      const custom = card.dataset.customPrice;
      return custom !== '' ? Number(custom) || 0 : variant.price;
    };

    const displayCompare = (card, variant) => {
      const custom = card.dataset.customCompare;
      return custom !== '' ? Number(custom) || 0 : variant.compare;
    };

    const setImage = (card, src, title) => {
      if (!src) return;
      const wrap = card.querySelector('.ivory-bundle__image-wrap');
      let image = card.querySelector('[data-product-image]');
      if (!image && wrap) {
        image = document.createElement('img');
        image.setAttribute('data-product-image', '');
        image.width = 800;
        image.height = 1000;
        image.loading = 'lazy';
        wrap.prepend(image);
      }
      if (!image) return;
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src = src;
      image.alt = title || '';
      card.querySelector('[data-product-placeholder]')?.remove();
    };

    const rebuildVariants = (card, product) => {
      const select = card.querySelector('[data-variant-select]');
      const single = card.querySelector('[data-single-variant]');
      const field = card.querySelector('[data-variant-field]');
      if (!select || !single || !product?.variants?.length) return;
      const firstAvailable = product.variants.find((variant) => variant.available) || product.variants[0];

      select.innerHTML = '';
      product.variants.forEach((variant) => {
        const option = document.createElement('option');
        option.value = variant.id;
        option.textContent = `${variant.title}${variant.available ? '' : ' — Esgotado'}`;
        option.disabled = !variant.available;
        option.selected = variant.id === firstAvailable.id;
        option.dataset.title = variant.title;
        option.dataset.price = variant.price;
        option.dataset.compare = variant.compare || 0;
        option.dataset.image = variant.image || product.image || '';
        option.dataset.available = String(Boolean(variant.available));
        select.appendChild(option);
      });

      const onlyOne = product.variants.length === 1;
      if (field) field.hidden = onlyOne;
      select.hidden = onlyOne;
      select.disabled = onlyOne;
      single.disabled = !onlyOne;
      single.value = firstAvailable.id;
      single.dataset.title = firstAvailable.title;
      single.dataset.price = firstAvailable.price;
      single.dataset.compare = firstAvailable.compare || 0;
      single.dataset.image = firstAvailable.image || product.image || '';
      single.dataset.available = String(Boolean(firstAvailable.available));
    };

    const updateCard = (root, card) => {
      const variant = getVariant(card);
      if (!variant) return;
      const price = displayPrice(card, variant);
      const compare = displayCompare(card, variant);
      const priceElement = card.querySelector('[data-card-price]');
      const compareElement = card.querySelector('[data-card-compare]');
      const compareLine = card.querySelector('[data-compare-line]');
      if (priceElement) priceElement.textContent = formatMoney(price);
      if (compareElement) compareElement.textContent = formatMoney(compare);
      if (compareLine) compareLine.hidden = !(compare > price);
      card.classList.toggle('is-unavailable', !variant.available);
      setImage(card, variant.image, card.dataset.activeProductTitle);

      const panel = card.closest('[data-step-panel]');
      const panelStep = Number(panel?.dataset.stepPanel) || 0;
      const next = panel?.querySelector('[data-step-next]');
      if (next) next.disabled = !variant.available;
      if (!variant.available && panelStep) {
        root._bundleCompleted?.delete(panelStep);
        panel?.classList.remove('is-complete');
        root.querySelector(`[data-step-indicator="${panelStep}"]`)?.classList.remove('is-complete');
      }
      updateSummary(root);
    };

    const syncProductTypeUI = (card, type) => {
      const normalizedType = String(type || '1');
      const panel = card.closest('[data-step-panel]');
      const typeScope = panel || card;
      const typeButtons = Array.from(typeScope.querySelectorAll('[data-product-type-choice]'));
      const activeTypeButton = typeButtons.find((button) => button.dataset.productTypeChoice === normalizedType);

      typeButtons.forEach((button) => {
        const active = button.dataset.productTypeChoice === normalizedType;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
        button.setAttribute('aria-selected', String(active));
      });

      card.dataset.activeProductType = normalizedType;
      card.dataset.activeTypeLabel = activeTypeButton?.dataset.typeLabel || card.dataset.activeTypeLabel || '';

      const visibleChoices = [];
      card.querySelectorAll('[data-product-choice]').forEach((button) => {
        const visible = button.dataset.productType === normalizedType;
        button.hidden = !visible;
        if (visible) visibleChoices.push(button);
      });

      const choices = card.querySelector('[data-product-choices]');
      if (choices) choices.hidden = visibleChoices.length < 2;

      return visibleChoices;
    };

    const selectProduct = (root, card, choice) => {
      const product = parseProduct(choice.dataset.jsonId);
      if (!product) return;

      const type = choice.dataset.productType || card.dataset.activeProductType || '1';
      syncProductTypeUI(card, type);

      card.querySelectorAll('[data-product-choice]').forEach((button) => {
        if (button.dataset.productType !== String(type)) return;
        const active = button === choice;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });

      card.dataset.activeProductId = product.id;
      card.dataset.activeProductTitle = product.title;
      const name = card.querySelector('[data-product-name]');
      if (name && card.dataset.fixedTitle !== 'true') name.textContent = product.title;
      const currentChoice = card.querySelector('[data-current-choice-label]');
      if (currentChoice) currentChoice.textContent = choice.dataset.choiceLabel || product.title;
      rebuildVariants(card, product);
      setImage(card, product.image, product.title);
      updateCard(root, card);
    };

    const selectProductType = (root, card, type) => {
      const visibleChoices = syncProductTypeUI(card, type);
      if (!visibleChoices.length) return;
      const savedChoice = visibleChoices.find((choice) => choice.classList.contains('is-active'));
      selectProduct(root, card, savedChoice || visibleChoices[0]);
    };

    const cardSelection = (card) => {
      const variant = getVariant(card);
      if (!variant) return null;
      const quantityInput = card.querySelector('[data-quantity-input]');
      const quantity = Math.max(1, Number(quantityInput?.value) || Number(card.dataset.quantity) || 1);
      return {
        card,
        id: variant.id,
        variantTitle: variant.title,
        available: variant.available,
        productId: card.dataset.activeProductId,
        productTitle: card.dataset.activeProductTitle,
        productType: card.dataset.activeProductType || '',
        productTypeLabel: card.dataset.activeTypeLabel || '',
        choiceLabel: card.querySelector('[data-current-choice-label]')?.textContent.trim() || '',
        image: variant.image,
        quantity,
        price: displayPrice(card, variant),
        compare: displayCompare(card, variant)
      };
    };

    const allSelections = (root) => Array.from(root.querySelectorAll('[data-bundle-card]')).map(cardSelection).filter(Boolean);

    const installmentText = (root, total) => {
      const count = Math.max(1, Number(root.dataset.installmentsCount) || 1);
      const template = root.dataset.installmentsTemplate || 'Em até [count]x de [value] sem juros';
      return template.replace('[count]', count).replace('[value]', formatMoney(total / count));
    };

    const updateSummary = (root) => {
      const selections = allSelections(root);
      const container = root.querySelector('[data-summary-items]');
      if (container) {
        container.innerHTML = selections.map((selection, index) => {
          const panel = selection.card.closest('[data-step-panel]');
          const label = selection.card.dataset.summaryLabel || `Item ${index + 1}`;
          const metaParts = [];
          if (selection.productTypeLabel) metaParts.push(selection.productTypeLabel);
          if (selection.choiceLabel) metaParts.push(selection.choiceLabel);
          if (selection.variantTitle && selection.variantTitle !== 'Default Title') metaParts.push(selection.variantTitle);
          if (selection.quantity > 1) metaParts.push(`Qtd. ${selection.quantity}`);
          return `
            <article class="ivory-bundle__summary-item" data-summary-step="${panel?.dataset.stepPanel || index + 1}">
              <div class="ivory-bundle__summary-thumb">${selection.image ? `<img src="${escapeHtml(selection.image)}" alt="" width="96" height="114" loading="lazy">` : ''}</div>
              <div class="ivory-bundle__summary-info">
                <span class="ivory-bundle__summary-label">${escapeHtml(label)}</span>
                <span class="ivory-bundle__summary-title">${escapeHtml(selection.productTitle)}</span>
                <span class="ivory-bundle__summary-meta">${escapeHtml(metaParts.join(' · '))}</span>
              </div>
              <strong class="ivory-bundle__summary-price">${formatMoney(selection.price * selection.quantity)}</strong>
            </article>
          `;
        }).join('');
      }

      const total = selections.reduce((sum, selection) => sum + selection.price * selection.quantity, 0);
      const compare = selections.reduce((sum, selection) => {
        const effectiveCompare = selection.compare > selection.price ? selection.compare : selection.price;
        return sum + effectiveCompare * selection.quantity;
      }, 0);
      const totalPrice = root.querySelector('[data-total-price]');
      const totalCompare = root.querySelector('[data-total-compare]');
      const savingsBadge = root.querySelector('[data-savings-badge]');
      const installments = root.querySelector('[data-total-installments]');
      if (totalPrice) totalPrice.textContent = formatMoney(total);
      if (totalCompare) {
        totalCompare.textContent = formatMoney(compare);
        totalCompare.hidden = !(compare > total);
      }
      if (savingsBadge) {
        savingsBadge.hidden = !(compare > total);
        const value = savingsBadge.querySelector('span');
        if (value) value.textContent = formatMoney(compare - total);
      }
      if (installments) installments.textContent = total ? installmentText(root, total) : '';
    };

    const showStep = (root, targetStep, unlock = false) => {
      const maxStep = Number(root.dataset.reviewStep) || 1;
      const step = Math.min(maxStep, Math.max(1, Number(targetStep) || 1));
      if (unlock) root._bundleUnlocked = Math.max(root._bundleUnlocked || 1, step);

      root.querySelectorAll('[data-step-panel]').forEach((panel) => {
        const active = Number(panel.dataset.stepPanel) === step;
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
      });
      root.querySelectorAll('[data-step-indicator]').forEach((indicator) => {
        const indicatorStep = Number(indicator.dataset.stepIndicator);
        const active = indicatorStep === step;
        const complete = root._bundleCompleted?.has(indicatorStep) || false;
        const unlocked = indicatorStep <= (root._bundleUnlocked || 1);
        indicator.classList.toggle('is-active', active);
        indicator.classList.toggle('is-complete', complete && !active);
        indicator.classList.toggle('is-unlocked', unlocked);
        indicator.setAttribute('aria-selected', String(active));
        indicator.setAttribute('aria-disabled', String(!unlocked));
        if (active) {
          const progress = indicator.parentElement;
          if (progress && progress.scrollWidth > progress.clientWidth) {
            const left = indicator.offsetLeft - (progress.clientWidth - indicator.offsetWidth) / 2;
            progress.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
          }
        }
      });
      root._bundleActiveStep = step;
      if (step === maxStep) updateSummary(root);
    };

    const advance = (root, targetStep) => {
      const currentStep = root._bundleActiveStep || 1;
      const panel = root.querySelector(`[data-step-panel="${currentStep}"]`);
      const card = panel?.querySelector('[data-bundle-card]');
      const selection = card ? cardSelection(card) : null;
      if (!selection?.available) {
        setStatus(root, root.dataset.emptyMessage, true);
        card?.classList.add('is-unavailable');
        return;
      }
      root._bundleCompleted.add(currentStep);
      panel?.classList.add('is-complete');
      setStatus(root, '');
      showStep(root, targetStep, true);
    };

    const setStatus = (root, message, error = false) => {
      const status = root.querySelector('[data-bundle-status]');
      if (!status) return;
      status.textContent = message || '';
      status.classList.toggle('is-error', error);
    };

    const wait = (ms) => new Promise((resolve) => window.setTimeout(resolve, ms));

    const removeCartDrawerReloadParam = () => {
      const url = new URL(window.location.href);
      if (!url.searchParams.has(CART_DRAWER_RELOAD_PARAM)) return;
      url.searchParams.delete(CART_DRAWER_RELOAD_PARAM);
      window.history.replaceState({}, document.title, `${url.pathname}${url.search}${url.hash}`);
    };

    const markCartDrawerForNextLoad = () => {
      try {
        sessionStorage.setItem(CART_DRAWER_RELOAD_FLAG, 'true');
      } catch (error) {}
    };

    const reloadAndOpenCartDrawer = () => {
      const url = new URL(window.location.href);
      url.searchParams.set(CART_DRAWER_RELOAD_PARAM, '1');
      window.location.assign(url.toString());
    };

    const shouldOpenCartDrawerAfterReload = () => {
      const url = new URL(window.location.href);
      const shouldOpenFromUrl = url.searchParams.get(CART_DRAWER_RELOAD_PARAM) === '1';

      try {
        const shouldOpen = sessionStorage.getItem(CART_DRAWER_RELOAD_FLAG) === 'true';
        if (shouldOpen) sessionStorage.removeItem(CART_DRAWER_RELOAD_FLAG);
        return shouldOpen || shouldOpenFromUrl;
      } catch (error) {
        return shouldOpenFromUrl;
      }
    };

    const openCartDrawerAfterReload = async () => {
      if (!shouldOpenCartDrawerAfterReload()) return;
      removeCartDrawerReloadParam();

      if (document.readyState !== 'complete') {
        await new Promise(resolve => window.addEventListener('load', resolve));
      }
      
      await wait(800);

      const trigger = document.querySelector([
        '[data-cart-drawer-trigger]',
        '[data-open-cart]',
        '[data-drawer-open="cart"]',
        '.header__icon--cart',
        '#cart-icon-bubble',
        '.cart-icon',
        '.header__cart',
        'a[href="/cart"]',
        'button[aria-controls*="cart" i]'
      ].join(', '));

      if (trigger) {
        trigger.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
      } else {
        document.body.classList.add('drawer-open');
        const drawer = document.querySelector('[data-cart-drawer], cart-drawer');
        if (drawer) {
          drawer.classList.add('active', 'is-open');
          drawer.setAttribute('aria-hidden', 'false');
          document.querySelector('[data-drawer-overlay]')?.classList.add('is-visible');
        }
      }
    };

    const mountAtAnchor = (root, attempt = 0) => {
      if (root.dataset.anchorMounted === 'true') return;
      const anchor = document.getElementById(root.dataset.anchorId || 'ancora-combos');
      const sectionWrapper = root.closest('.shopify-section') || root;

      if (anchor && sectionWrapper && !sectionWrapper.contains(anchor)) {
        if (sectionWrapper.parentElement !== anchor) anchor.appendChild(sectionWrapper);
        root.dataset.anchorMounted = 'true';
        return;
      }

      if (!anchor && attempt < 20) {
        window.setTimeout(() => mountAtAnchor(root, attempt + 1), 150);
      }
    };

    const addBundle = async (root) => {
      const selections = allSelections(root);
      const expected = Number(root.dataset.itemsCount) || 0;
      const invalidIndex = selections.findIndex((selection) => !selection.available);
      
      if (selections.length !== expected || invalidIndex >= 0) {
        const target = invalidIndex >= 0 ? invalidIndex + 1 : 1;
        setStatus(root, root.dataset.emptyMessage, true);
        showStep(root, target, true);
        return;
      }

      const button = root.querySelector('[data-add-bundle]');
      const label = button?.textContent;
      if (button) {
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        button.textContent = 'Adicionando…';
      }
      setStatus(root, '');

      try {
        const response = await fetch(window.routes?.cart_add_url || `${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: selections.map((selection, index) => ({
              id: selection.id,
              quantity: selection.quantity,
              properties: {
                _combo_id: root.dataset.sectionId,
                _combo: root.dataset.comboTitle,
                _item_do_combo: index + 1,
                _tipo_do_produto: selection.productTypeLabel || '',
                _cor_do_produto: selection.choiceLabel || ''
              }
            }))
          })
        });
        
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || root.dataset.cartError);

        setStatus(root, root.dataset.cartSuccess);

        if (button) {
          button.hidden = true;
          button.disabled = true;
        }

        markCartDrawerForNextLoad();
        reloadAndOpenCartDrawer();
        return;

      } catch (error) {
        setStatus(root, error.message || root.dataset.cartError, true);
      } finally {
        if (button && !button.hidden) {
          button.disabled = false;
          button.removeAttribute('aria-busy');
          button.textContent = label;
        }
      }
    };

    const bind = (root) => {
      if (root.dataset.bundleBound === 'true') return;
      root.dataset.bundleBound = 'true';
      mountAtAnchor(root);
      root._bundleActiveStep = 1;
      root._bundleUnlocked = 1;
      root._bundleCompleted = new Set();

      root.querySelectorAll('[data-bundle-card]').forEach((card) => {
        const panel = card.closest('[data-step-panel]');
        const initialType = card.dataset.activeProductType || panel?.querySelector('[data-product-type-choice].is-active')?.dataset.productTypeChoice || panel?.querySelector('[data-product-type-choice]:not(:disabled)')?.dataset.productTypeChoice || '1';
        const hasChoices = card.querySelector('[data-product-choice]');
        if (hasChoices) selectProductType(root, card, initialType);
        else updateCard(root, card);
      });
      updateSummary(root);

      root.addEventListener('click', (event) => {
        const typeChoice = event.target.closest('[data-product-type-choice]');
        if (typeChoice && root.contains(typeChoice)) {
          if (typeChoice.disabled) return;
          const panel = typeChoice.closest('[data-step-panel]');
          const card = panel?.querySelector('[data-bundle-card]');
          if (card) selectProductType(root, card, typeChoice.dataset.productTypeChoice);
          return;
        }

        const choice = event.target.closest('[data-product-choice]');
        if (choice && root.contains(choice)) {
          selectProduct(root, choice.closest('[data-bundle-card]'), choice);
          return;
        }

        const quantityButton = event.target.closest('[data-quantity-change]');
        if (quantityButton && root.contains(quantityButton)) {
          const input = quantityButton.parentElement.querySelector('[data-quantity-input]');
          const next = Math.min(Number(input.max) || 99, Math.max(Number(input.min) || 1, (Number(input.value) || 1) + Number(quantityButton.dataset.quantityChange)));
          input.value = next;
          input.dispatchEvent(new Event('change', { bubbles: true }));
          return;
        }

        const next = event.target.closest('[data-step-next]');
        if (next && root.contains(next)) {
          advance(root, next.dataset.stepNext);
          return;
        }

        const back = event.target.closest('[data-step-back]');
        if (back && root.contains(back)) {
          showStep(root, back.dataset.stepBack, true);
          return;
        }

        const indicator = event.target.closest('[data-step-indicator]');
        if (indicator && root.contains(indicator) && indicator.classList.contains('is-unlocked')) {
          showStep(root, indicator.dataset.stepIndicator);
          return;
        }

        if (event.target.closest('[data-add-bundle]')) {
          addBundle(root);
          return;
        }
      });

      root.addEventListener('change', (event) => {
        const card = event.target.closest('[data-bundle-card]');
        if (!card) return;
        if (event.target.matches('[data-quantity-input]')) {
          event.target.value = Math.min(Number(event.target.max) || 99, Math.max(Number(event.target.min) || 1, Number(event.target.value) || 1));
        }
        if (event.target.matches('[data-variant-select], [data-quantity-input]')) updateCard(root, card);
      });

      showStep(root, 1);
    };

    const init = (scope = document) => scope.querySelectorAll(ROOT_SELECTOR).forEach(bind);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        init();
        openCartDrawerAfterReload();
      });
    } else {
      init();
      openCartDrawerAfterReload();
    }
    
    document.addEventListener('shopify:section:load', (event) => init(event.target));
    document.addEventListener('shopify:block:select', (event) => {
      const root = event.target.closest(ROOT_SELECTOR);
      if (!root) return;
      const panel = root.querySelector(`[data-block-id="${event.detail.blockId}"]`);
      if (panel) showStep(root, panel.dataset.stepPanel, true);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["IVR-COMBOSTEPS"] && !Shopify.designMode) return;
  try {
    
 (() => {
    const ROOT_SELECTOR = '[data-ivory-bundle]';
    const CART_DRAWER_RELOAD_FLAG = 'ivoryBundleOpenCartDrawerAfterReload';
    const CART_DRAWER_RELOAD_PARAM = 'open_cart_drawer';

    const escapeHtml = (value) => String(value ?? '')
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');

    const formatMoney = (cents) => {
      const currency = window.Shopify?.currency?.active || 'BRL';
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'pt-BR', {
          style: 'currency',
          currency
        }).format((Number(cents) || 0) / 100);
      } catch (error) {
        return `R$ ${((Number(cents) || 0) / 100).toFixed(2).replace('.', ',')}`;
      }
    };

    const parseProduct = (id) => {
      const source = document.getElementById(id);
      if (!source) return null;
      try { return JSON.parse(source.textContent); } catch (error) { return null; }
    };

    const getVariant = (card) => {
      const select = card.querySelector('[data-variant-select]');
      const single = card.querySelector('[data-single-variant]');
      const source = select && !select.hidden ? select.selectedOptions[0] : single;
      const id = select && !select.hidden ? select.value : single?.value;
      if (!source || !id) return null;
      return {
        id: Number(id),
        title: source.dataset.title || '',
        price: Number(source.dataset.price) || 0,
        compare: Number(source.dataset.compare) || 0,
        image: source.dataset.image || '',
        available: source.dataset.available !== 'false' && !source.disabled
      };
    };

    const displayPrice = (card, variant) => {
      const custom = card.dataset.customPrice;
      return custom !== '' ? Number(custom) || 0 : variant.price;
    };

    const displayCompare = (card, variant) => {
      const custom = card.dataset.customCompare;
      return custom !== '' ? Number(custom) || 0 : variant.compare;
    };

    const setImage = (card, src, title) => {
      if (!src) return;
      const wrap = card.querySelector('.ivory-bundle__image-wrap');
      let image = card.querySelector('[data-product-image]');
      if (!image && wrap) {
        image = document.createElement('img');
        image.setAttribute('data-product-image', '');
        image.width = 800;
        image.height = 1000;
        image.loading = 'lazy';
        wrap.prepend(image);
      }
      if (!image) return;
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src = src;
      image.alt = title || '';
      card.querySelector('[data-product-placeholder]')?.remove();
    };

    const rebuildVariants = (card, product) => {
      const select = card.querySelector('[data-variant-select]');
      const single = card.querySelector('[data-single-variant]');
      const field = card.querySelector('[data-variant-field]');
      if (!select || !single || !product?.variants?.length) return;
      const firstAvailable = product.variants.find((variant) => variant.available) || product.variants[0];

      select.innerHTML = '';
      product.variants.forEach((variant) => {
        const option = document.createElement('option');
        option.value = variant.id;
        option.textContent = `${variant.title}${variant.available ? '' : ' — Esgotado'}`;
        option.disabled = !variant.available;
        option.selected = variant.id === firstAvailable.id;
        option.dataset.title = variant.title;
        option.dataset.price = variant.price;
        option.dataset.compare = variant.compare || 0;
        option.dataset.image = variant.image || product.image || '';
        option.dataset.available = String(Boolean(variant.available));
        select.appendChild(option);
      });

      const onlyOne = product.variants.length === 1;
      if (field) field.hidden = onlyOne;
      select.hidden = onlyOne;
      select.disabled = onlyOne;
      single.disabled = !onlyOne;
      single.value = firstAvailable.id;
      single.dataset.title = firstAvailable.title;
      single.dataset.price = firstAvailable.price;
      single.dataset.compare = firstAvailable.compare || 0;
      single.dataset.image = firstAvailable.image || product.image || '';
      single.dataset.available = String(Boolean(firstAvailable.available));
    };

    const updateCard = (root, card) => {
      const variant = getVariant(card);
      if (!variant) return;
      const price = displayPrice(card, variant);
      const compare = displayCompare(card, variant);
      const priceElement = card.querySelector('[data-card-price]');
      const compareElement = card.querySelector('[data-card-compare]');
      const compareLine = card.querySelector('[data-compare-line]');
      if (priceElement) priceElement.textContent = formatMoney(price);
      if (compareElement) compareElement.textContent = formatMoney(compare);
      if (compareLine) compareLine.hidden = !(compare > price);
      card.classList.toggle('is-unavailable', !variant.available);
      setImage(card, variant.image, card.dataset.activeProductTitle);

      const panel = card.closest('[data-step-panel]');
      const panelStep = Number(panel?.dataset.stepPanel) || 0;
      const next = panel?.querySelector('[data-step-next]');
      if (next) next.disabled = !variant.available;
      if (!variant.available && panelStep) {
        root._bundleCompleted?.delete(panelStep);
        panel?.classList.remove('is-complete');
        root.querySelector(`[data-step-indicator="${panelStep}"]`)?.classList.remove('is-complete');
      }
      updateSummary(root);
    };

    const selectProduct = (root, card, choice) => {
      const product = parseProduct(choice.dataset.jsonId);
      if (!product) return;
      card.querySelectorAll('[data-product-choice]').forEach((button) => {
        const active = button === choice;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });

      card.dataset.activeProductId = product.id;
      card.dataset.activeProductTitle = product.title;
      const name = card.querySelector('[data-product-name]');
      if (name && card.dataset.fixedTitle !== 'true') name.textContent = product.title;
      const currentChoice = card.querySelector('[data-current-choice-label]');
      if (currentChoice) currentChoice.textContent = choice.dataset.choiceLabel || product.title;
      rebuildVariants(card, product);
      setImage(card, product.image, product.title);
      updateCard(root, card);
    };

    const cardSelection = (card) => {
      const variant = getVariant(card);
      if (!variant) return null;
      const quantityInput = card.querySelector('[data-quantity-input]');
      const quantity = Math.max(1, Number(quantityInput?.value) || Number(card.dataset.quantity) || 1);
      return {
        card,
        id: variant.id,
        variantTitle: variant.title,
        available: variant.available,
        productId: card.dataset.activeProductId,
        productTitle: card.dataset.activeProductTitle,
        choiceLabel: card.querySelector('[data-current-choice-label]')?.textContent.trim() || '',
        image: variant.image,
        quantity,
        price: displayPrice(card, variant),
        compare: displayCompare(card, variant)
      };
    };

    const allSelections = (root) => Array.from(root.querySelectorAll('[data-bundle-card]')).map(cardSelection).filter(Boolean);

    const installmentText = (root, total) => {
      const count = Math.max(1, Number(root.dataset.installmentsCount) || 1);
      const template = root.dataset.installmentsTemplate || 'Em até [count]x de [value] sem juros';
      return template.replace('[count]', count).replace('[value]', formatMoney(total / count));
    };

    const updateSummary = (root) => {
      const selections = allSelections(root);
      const container = root.querySelector('[data-summary-items]');
      if (container) {
        container.innerHTML = selections.map((selection, index) => {
          const panel = selection.card.closest('[data-step-panel]');
          const label = selection.card.dataset.summaryLabel || `Item ${index + 1}`;
          const metaParts = [];
          if (selection.choiceLabel) metaParts.push(selection.choiceLabel);
          if (selection.variantTitle && selection.variantTitle !== 'Default Title') metaParts.push(selection.variantTitle);
          if (selection.quantity > 1) metaParts.push(`Qtd. ${selection.quantity}`);
          return `
            <article class="ivory-bundle__summary-item" data-summary-step="${panel?.dataset.stepPanel || index + 1}">
              <div class="ivory-bundle__summary-thumb">${selection.image ? `<img src="${escapeHtml(selection.image)}" alt="" width="96" height="114" loading="lazy">` : ''}</div>
              <div class="ivory-bundle__summary-info">
                <span class="ivory-bundle__summary-label">${escapeHtml(label)}</span>
                <span class="ivory-bundle__summary-title">${escapeHtml(selection.productTitle)}</span>
                <span class="ivory-bundle__summary-meta">${escapeHtml(metaParts.join(' · '))}</span>
              </div>
              <strong class="ivory-bundle__summary-price">${formatMoney(selection.price * selection.quantity)}</strong>
            </article>
          `;
        }).join('');
      }

      const total = selections.reduce((sum, selection) => sum + selection.price * selection.quantity, 0);
      const compare = selections.reduce((sum, selection) => {
        const effectiveCompare = selection.compare > selection.price ? selection.compare : selection.price;
        return sum + effectiveCompare * selection.quantity;
      }, 0);
      const totalPrice = root.querySelector('[data-total-price]');
      const totalCompare = root.querySelector('[data-total-compare]');
      const savingsBadge = root.querySelector('[data-savings-badge]');
      const installments = root.querySelector('[data-total-installments]');
      if (totalPrice) totalPrice.textContent = formatMoney(total);
      if (totalCompare) {
        totalCompare.textContent = formatMoney(compare);
        totalCompare.hidden = !(compare > total);
      }
      if (savingsBadge) {
        savingsBadge.hidden = !(compare > total);
        const value = savingsBadge.querySelector('span');
        if (value) value.textContent = formatMoney(compare - total);
      }
      if (installments) installments.textContent = total ? installmentText(root, total) : '';
    };

    const showStep = (root, targetStep, unlock = false) => {
      const maxStep = Number(root.dataset.reviewStep) || 1;
      const step = Math.min(maxStep, Math.max(1, Number(targetStep) || 1));
      if (unlock) root._bundleUnlocked = Math.max(root._bundleUnlocked || 1, step);

      root.querySelectorAll('[data-step-panel]').forEach((panel) => {
        const active = Number(panel.dataset.stepPanel) === step;
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
      });
      root.querySelectorAll('[data-step-indicator]').forEach((indicator) => {
        const indicatorStep = Number(indicator.dataset.stepIndicator);
        const active = indicatorStep === step;
        const complete = root._bundleCompleted?.has(indicatorStep) || false;
        const unlocked = indicatorStep <= (root._bundleUnlocked || 1);
        indicator.classList.toggle('is-active', active);
        indicator.classList.toggle('is-complete', complete && !active);
        indicator.classList.toggle('is-unlocked', unlocked);
        indicator.setAttribute('aria-selected', String(active));
        indicator.setAttribute('aria-disabled', String(!unlocked));
        if (active) {
          const progress = indicator.parentElement;
          if (progress && progress.scrollWidth > progress.clientWidth) {
            const left = indicator.offsetLeft - (progress.clientWidth - indicator.offsetWidth) / 2;
            progress.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
          }
        }
      });
      root._bundleActiveStep = step;
      if (step === maxStep) updateSummary(root);
    };

    const advance = (root, targetStep) => {
      const currentStep = root._bundleActiveStep || 1;
      const panel = root.querySelector(`[data-step-panel="${currentStep}"]`);
      const card = panel?.querySelector('[data-bundle-card]');
      const selection = card ? cardSelection(card) : null;
      if (!selection?.available) {
        setStatus(root, root.dataset.emptyMessage, true);
        card?.classList.add('is-unavailable');
        return;
      }
      root._bundleCompleted.add(currentStep);
      panel?.classList.add('is-complete');
      setStatus(root, '');
      showStep(root, targetStep, true);
    };

    const setStatus = (root, message, error = false) => {
      const status = root.querySelector('[data-bundle-status]');
      if (!status) return;
      status.textContent = message || '';
      status.classList.toggle('is-error', error);
    };

    const wait = (ms) => new Promise((resolve) => window.setTimeout(resolve, ms));

    const removeCartDrawerReloadParam = () => {
      const url = new URL(window.location.href);
      if (!url.searchParams.has(CART_DRAWER_RELOAD_PARAM)) return;
      url.searchParams.delete(CART_DRAWER_RELOAD_PARAM);
      window.history.replaceState({}, document.title, `${url.pathname}${url.search}${url.hash}`);
    };

    const markCartDrawerForNextLoad = () => {
      try {
        sessionStorage.setItem(CART_DRAWER_RELOAD_FLAG, 'true');
      } catch (error) {}
    };

    const reloadAndOpenCartDrawer = () => {
      const url = new URL(window.location.href);
      url.searchParams.set(CART_DRAWER_RELOAD_PARAM, '1');
      window.location.assign(url.toString());
    };

    const shouldOpenCartDrawerAfterReload = () => {
      const url = new URL(window.location.href);
      const shouldOpenFromUrl = url.searchParams.get(CART_DRAWER_RELOAD_PARAM) === '1';

      try {
        const shouldOpen = sessionStorage.getItem(CART_DRAWER_RELOAD_FLAG) === 'true';
        if (shouldOpen) sessionStorage.removeItem(CART_DRAWER_RELOAD_FLAG);
        return shouldOpen || shouldOpenFromUrl;
      } catch (error) {
        return shouldOpenFromUrl;
      }
    };

    const openCartDrawerAfterReload = async () => {
      if (!shouldOpenCartDrawerAfterReload()) return;
      removeCartDrawerReloadParam();

      // Aguarda até o evento 'load' total da página para garantir
      // que o JavaScript do seu tema já montou visualmente os itens do carrinho.
      if (document.readyState !== 'complete') {
        await new Promise(resolve => window.addEventListener('load', resolve));
      }
      
      // Delay extra de segurança para a requisição de rede do tema finalizar
      await wait(800);

      // Procura o botão do carrinho do seu tema usando vários seletores comuns
      const trigger = document.querySelector([
        '[data-cart-drawer-trigger]',
        '[data-open-cart]',
        '[data-drawer-open="cart"]',
        '.header__icon--cart',
        '#cart-icon-bubble',
        '.cart-icon',
        '.header__cart',
        'a[href="/cart"]',
        'button[aria-controls*="cart" i]'
      ].join(', '));

      if (trigger) {
        // Dispara o clique como se o próprio usuário estivesse abrindo o carrinho
        trigger.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
      } else {
        // Fallback: força o CSS caso nenhum botão seja encontrado
        document.body.classList.add('drawer-open');
        const drawer = document.querySelector('[data-cart-drawer], cart-drawer');
        if (drawer) {
          drawer.classList.add('active', 'is-open');
          drawer.setAttribute('aria-hidden', 'false');
          document.querySelector('[data-drawer-overlay]')?.classList.add('is-visible');
        }
      }
    };

    const mountAtAnchor = (root, attempt = 0) => {
      if (root.dataset.anchorMounted === 'true') return;
      const anchor = document.getElementById(root.dataset.anchorId || 'ancora-combos');
      const sectionWrapper = root.closest('.shopify-section') || root;

      if (anchor && sectionWrapper && !sectionWrapper.contains(anchor)) {
        if (sectionWrapper.parentElement !== anchor) anchor.appendChild(sectionWrapper);
        root.dataset.anchorMounted = 'true';
        return;
      }

      if (!anchor && attempt < 20) {
        window.setTimeout(() => mountAtAnchor(root, attempt + 1), 150);
      }
    };

    const addBundle = async (root) => {
      const selections = allSelections(root);
      const expected = Number(root.dataset.itemsCount) || 0;
      const invalidIndex = selections.findIndex((selection) => !selection.available);
      
      if (selections.length !== expected || invalidIndex >= 0) {
        const target = invalidIndex >= 0 ? invalidIndex + 1 : 1;
        setStatus(root, root.dataset.emptyMessage, true);
        showStep(root, target, true);
        return;
      }

      const button = root.querySelector('[data-add-bundle]');
      const label = button?.textContent;
      if (button) {
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        button.textContent = 'Adicionando…';
      }
      setStatus(root, '');

      try {
        const response = await fetch(window.routes?.cart_add_url || `${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: selections.map((selection, index) => ({
              id: selection.id,
              quantity: selection.quantity,
              properties: {
                _combo_id: root.dataset.sectionId,
                _combo: root.dataset.comboTitle,
                _item_do_combo: index + 1
              }
            }))
          })
        });
        
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || root.dataset.cartError);

        setStatus(root, root.dataset.cartSuccess);

        if (button) {
          button.hidden = true;
          button.disabled = true;
        }

        markCartDrawerForNextLoad();
        reloadAndOpenCartDrawer();
        return;

      } catch (error) {
        setStatus(root, error.message || root.dataset.cartError, true);
      } finally {
        if (button && !button.hidden) {
          button.disabled = false;
          button.removeAttribute('aria-busy');
          button.textContent = label;
        }
      }
    };

    const bind = (root) => {
      if (root.dataset.bundleBound === 'true') return;
      root.dataset.bundleBound = 'true';
      mountAtAnchor(root);
      root._bundleActiveStep = 1;
      root._bundleUnlocked = 1;
      root._bundleCompleted = new Set();

      root.querySelectorAll('[data-bundle-card]').forEach((card) => {
        const activeChoice = card.querySelector('[data-product-choice].is-active') || card.querySelector('[data-product-choice]');
        if (activeChoice) selectProduct(root, card, activeChoice);
        else updateCard(root, card);
      });
      updateSummary(root);

      root.addEventListener('click', (event) => {
        const choice = event.target.closest('[data-product-choice]');
        if (choice && root.contains(choice)) {
          selectProduct(root, choice.closest('[data-bundle-card]'), choice);
          return;
        }

        const quantityButton = event.target.closest('[data-quantity-change]');
        if (quantityButton && root.contains(quantityButton)) {
          const input = quantityButton.parentElement.querySelector('[data-quantity-input]');
          const next = Math.min(Number(input.max) || 99, Math.max(Number(input.min) || 1, (Number(input.value) || 1) + Number(quantityButton.dataset.quantityChange)));
          input.value = next;
          input.dispatchEvent(new Event('change', { bubbles: true }));
          return;
        }

        const next = event.target.closest('[data-step-next]');
        if (next && root.contains(next)) {
          advance(root, next.dataset.stepNext);
          return;
        }

        const back = event.target.closest('[data-step-back]');
        if (back && root.contains(back)) {
          showStep(root, back.dataset.stepBack, true);
          return;
        }

        const indicator = event.target.closest('[data-step-indicator]');
        if (indicator && root.contains(indicator) && indicator.classList.contains('is-unlocked')) {
          showStep(root, indicator.dataset.stepIndicator);
          return;
        }

        if (event.target.closest('[data-add-bundle]')) {
          addBundle(root);
          return;
        }
      });

      root.addEventListener('change', (event) => {
        const card = event.target.closest('[data-bundle-card]');
        if (!card) return;
        if (event.target.matches('[data-quantity-input]')) {
          event.target.value = Math.min(Number(event.target.max) || 99, Math.max(Number(event.target.min) || 1, Number(event.target.value) || 1));
        }
        if (event.target.matches('[data-variant-select], [data-quantity-input]')) updateCard(root, card);
      });

      showStep(root, 1);
    };

    const init = (scope = document) => scope.querySelectorAll(ROOT_SELECTOR).forEach(bind);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        init();
        openCartDrawerAfterReload();
      });
    } else {
      init();
      openCartDrawerAfterReload();
    }
    
    document.addEventListener('shopify:section:load', (event) => init(event.target));
    document.addEventListener('shopify:block:select', (event) => {
      const root = event.target.closest(ROOT_SELECTOR);
      if (!root) return;
      const panel = root.querySelector(`[data-block-id="${event.detail.blockId}"]`);
      if (panel) showStep(root, panel.dataset.stepPanel, true);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-product-showcase]';

    const updateScrollbar = (root) => {
      const viewport = root.querySelector('[data-showcase-viewport]');
      const scrollbar = root.querySelector('[data-showcase-scrollbar]');
      const track = root.querySelector('[data-showcase-scrollbar-track]');
      const thumb = root.querySelector('[data-showcase-scrollbar-thumb]');
      if (!viewport || !scrollbar || !track || !thumb) return;

      const maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
      const trackWidth = track.clientWidth;
      const ratio = viewport.scrollWidth > 0 ? viewport.clientWidth / viewport.scrollWidth : 1;
      const minThumb = parseFloat(getComputedStyle(root).getPropertyValue('--ps-scrollbar-min-thumb')) || 48;
      const thumbWidth = Math.min(trackWidth, Math.max(minThumb, trackWidth * ratio));
      const maxTravel = Math.max(0, trackWidth - thumbWidth);
      const progress = maxScroll > 0 ? Math.min(1, Math.max(0, viewport.scrollLeft / maxScroll)) : 0;

      thumb.style.width = `${thumbWidth}px`;
      thumb.style.transform = `translate3d(${maxTravel * progress}px, 0, 0)`;
      scrollbar.classList.toggle('is-inactive', maxScroll <= 2 || trackWidth <= 0);
      scrollbar.setAttribute('aria-valuenow', String(Math.round(progress * 100)));
    };

    const getScrollPositions = (root) => {
      const viewport = root.querySelector('[data-showcase-viewport]');
      const items = Array.from(root.querySelectorAll('.product-showcase__item'));
      if (!viewport || !items.length) return [];

      const maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
      if (maxScroll <= 2) return [0];
      const firstOffset = items[0].offsetLeft;
      const positions = [];

      items.forEach((item) => {
        const position = Math.min(maxScroll, Math.max(0, item.offsetLeft - firstOffset));
        if (!positions.some((current) => Math.abs(current - position) <= 2)) positions.push(position);
      });

      if (!positions.some((current) => Math.abs(current - maxScroll) <= 2)) positions.push(maxScroll);
      return positions.sort((a, b) => a - b);
    };

    const updateDots = (root) => {
      const viewport = root.querySelector('[data-showcase-viewport]');
      const container = root.querySelector('[data-showcase-dots]');
      if (!viewport || !container) return;

      const positions = getScrollPositions(root);
      const positionKey = positions.map((position) => Math.round(position)).join(',');
      if (container.dataset.positionKey !== positionKey) {
        const fragment = document.createDocumentFragment();
        positions.forEach((position, index) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'product-showcase__dot';
          dot.dataset.showcaseDot = String(index);
          dot.setAttribute('aria-label', `Ir para posição ${index + 1}`);
          fragment.appendChild(dot);
        });
        container.replaceChildren(fragment);
        container.dataset.positionKey = positionKey;
        container.dataset.positions = JSON.stringify(positions);
      }

      container.classList.toggle('is-inactive', positions.length <= 1);
      let activeIndex = 0;
      let shortestDistance = Infinity;
      positions.forEach((position, index) => {
        const distance = Math.abs(viewport.scrollLeft - position);
        if (distance < shortestDistance) {
          shortestDistance = distance;
          activeIndex = index;
        }
      });

      container.querySelectorAll('[data-showcase-dot]').forEach((dot, index) => {
        const active = index === activeIndex;
        dot.classList.toggle('is-active', active);
        if (active) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    };

    const updateControls = (root) => {
      const viewport = root.querySelector('[data-showcase-viewport]');
      if (!viewport) return;
      const maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth - 2);
      const previous = root.querySelector('[data-showcase-direction="prev"]');
      const next = root.querySelector('[data-showcase-direction="next"]');
      if (previous) previous.disabled = viewport.scrollLeft <= 2;
      if (next) next.disabled = viewport.scrollLeft >= maxScroll;
      updateScrollbar(root);
      updateDots(root);
    };

    const scrollShowcase = (root, direction) => {
      const viewport = root.querySelector('[data-showcase-viewport]');
      const items = Array.from(root.querySelectorAll('.product-showcase__item'));
      if (!viewport || !items.length) return;
      let distance = viewport.clientWidth * .8;
      if (items.length > 1) distance = Math.abs(items[1].offsetLeft - items[0].offsetLeft);
      viewport.scrollBy({ left: direction === 'next' ? distance : -distance, behavior: 'smooth' });
    };

    const setStatus = (root, message = '', isError = false) => {
      const status = root.querySelector('[data-showcase-status]');
      if (!status) return;
      status.textContent = message;
      status.classList.toggle('is-error', isError);
    };

    const openCartDrawer = () => {
      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') {
        drawer.open();
        return;
      }
      const trigger = document.querySelector('[data-testid="cart-drawer-trigger"], [data-cart-drawer-trigger], #cart-icon-bubble, .header__icon--cart, button[aria-controls*="cart" i], a[aria-controls*="cart" i]');
      if (trigger) trigger.click();
    };

    const addProduct = async (root, button) => {
      const variantId = Number(button.dataset.variantId);
      if (!variantId || button.getAttribute('aria-busy') === 'true') return;
      button.setAttribute('aria-busy', 'true');
      button.disabled = true;
      setStatus(root);

      try {
        const base = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
        const endpoint = window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : `${base}cart/add.js`;
        const response = await fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: variantId, quantity: 1 }],
            sections: ['cart-drawer', 'cart-icon-bubble'],
            sections_url: window.location.pathname
          })
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || 'Não foi possível adicionar o produto.');

        const drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.renderContents === 'function' && result.sections) drawer.renderContents(result);
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { source: 'product-showcase' } }));
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: result } }));
        openCartDrawer();
      } catch (error) {
        setStatus(root, error.message || 'Não foi possível adicionar o produto.', true);
      } finally {
        button.removeAttribute('aria-busy');
        button.disabled = false;
      }
    };

    const bind = (root) => {
      if (!root || root.dataset.showcaseBound === 'true') return;
      root.dataset.showcaseBound = 'true';
      const viewport = root.querySelector('[data-showcase-viewport]');
      const scrollbar = root.querySelector('[data-showcase-scrollbar]');
      const scrollbarTrack = root.querySelector('[data-showcase-scrollbar-track]');
      const scrollbarThumb = root.querySelector('[data-showcase-scrollbar-thumb]');

      root.addEventListener('click', (event) => {
        const addButton = event.target.closest('[data-showcase-add]');
        if (addButton && root.contains(addButton)) {
          addProduct(root, addButton);
          return;
        }
        const dot = event.target.closest('[data-showcase-dot]');
        if (dot && root.contains(dot) && viewport) {
          const container = dot.closest('[data-showcase-dots]');
          const positions = JSON.parse(container.dataset.positions || '[]');
          const position = positions[Number(dot.dataset.showcaseDot)];
          if (Number.isFinite(position)) viewport.scrollTo({ left: position, behavior: 'smooth' });
          return;
        }
        const arrow = event.target.closest('[data-showcase-direction]');
        if (!arrow || !root.contains(arrow)) return;
        scrollShowcase(root, arrow.dataset.showcaseDirection);
      });

      if (viewport) {
        let scheduled = false;
        viewport.addEventListener('scroll', () => {
          if (scheduled) return;
          scheduled = true;
          requestAnimationFrame(() => {
            updateControls(root);
            scheduled = false;
          });
        }, { passive: true });

        if ('ResizeObserver' in window) {
          const observer = new ResizeObserver(() => updateControls(root));
          observer.observe(viewport);
        }
      }

      if (viewport && scrollbar && scrollbarTrack && scrollbarThumb) {
        let dragging = false;
        let startX = 0;
        let startScroll = 0;

        const finishDrag = (event) => {
          if (!dragging) return;
          dragging = false;
          scrollbar.classList.remove('is-dragging');
          if (scrollbar.hasPointerCapture(event.pointerId)) scrollbar.releasePointerCapture(event.pointerId);
        };

        scrollbar.addEventListener('pointerdown', (event) => {
          const maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
          if (maxScroll <= 0) return;

          if (event.target === scrollbarThumb) {
            dragging = true;
            startX = event.clientX;
            startScroll = viewport.scrollLeft;
            scrollbar.classList.add('is-dragging');
            scrollbar.setPointerCapture(event.pointerId);
          } else {
            const rect = scrollbarTrack.getBoundingClientRect();
            const progress = Math.min(1, Math.max(0, (event.clientX - rect.left) / rect.width));
            viewport.scrollTo({ left: maxScroll * progress, behavior: 'smooth' });
          }
          event.preventDefault();
        });

        scrollbar.addEventListener('pointermove', (event) => {
          if (!dragging) return;
          const maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
          const maxTravel = Math.max(1, scrollbarTrack.clientWidth - scrollbarThumb.offsetWidth);
          viewport.scrollLeft = startScroll + ((event.clientX - startX) / maxTravel) * maxScroll;
        });

        scrollbar.addEventListener('pointerup', finishDrag);
        scrollbar.addEventListener('pointercancel', finishDrag);

        scrollbar.addEventListener('keydown', (event) => {
          const maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
          let target = viewport.scrollLeft;
          if (event.key === 'ArrowLeft') target -= viewport.clientWidth * .2;
          else if (event.key === 'ArrowRight') target += viewport.clientWidth * .2;
          else if (event.key === 'PageUp') target -= viewport.clientWidth * .8;
          else if (event.key === 'PageDown') target += viewport.clientWidth * .8;
          else if (event.key === 'Home') target = 0;
          else if (event.key === 'End') target = maxScroll;
          else return;
          event.preventDefault();
          viewport.scrollTo({ left: Math.min(maxScroll, Math.max(0, target)), behavior: 'smooth' });
        });
      }

      updateControls(root);
    };

    const init = (scope = document) => scope.querySelectorAll(selector).forEach(bind);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
    else init();
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-combo-builder"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const ROOT_SELECTOR = '[data-ivory-bundle]';

    const escapeHtml = (value) => String(value ?? '')
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');

    const formatMoney = (cents) => {
      const currency = window.Shopify?.currency?.active || 'BRL';
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'pt-BR', {
          style: 'currency',
          currency
        }).format((Number(cents) || 0) / 100);
      } catch (error) {
        return `R$ ${((Number(cents) || 0) / 100).toFixed(2).replace('.', ',')}`;
      }
    };

    const parseProduct = (id) => {
      const source = document.getElementById(id);
      if (!source) return null;
      try { return JSON.parse(source.textContent); } catch (error) { return null; }
    };

    const getVariant = (card) => {
      const select = card.querySelector('[data-variant-select]');
      const single = card.querySelector('[data-single-variant]');
      const source = select && !select.hidden ? select.selectedOptions[0] : single;
      const id = select && !select.hidden ? select.value : single?.value;
      if (!source || !id) return null;
      return {
        id: Number(id),
        title: source.dataset.title || '',
        price: Number(source.dataset.price) || 0,
        compare: Number(source.dataset.compare) || 0,
        image: source.dataset.image || '',
        available: source.dataset.available !== 'false' && !source.disabled
      };
    };

    const displayPrice = (card, variant) => {
      const custom = card.dataset.customPrice;
      return custom !== '' ? Number(custom) || 0 : variant.price;
    };

    const displayCompare = (card, variant) => {
      const custom = card.dataset.customCompare;
      return custom !== '' ? Number(custom) || 0 : variant.compare;
    };

    const setImage = (card, src, title) => {
      if (!src) return;
      const wrap = card.querySelector('.ivory-bundle__image-wrap');
      let image = card.querySelector('[data-product-image]');
      if (!image && wrap) {
        image = document.createElement('img');
        image.setAttribute('data-product-image', '');
        image.width = 800;
        image.height = 1000;
        image.loading = 'lazy';
        wrap.prepend(image);
      }
      if (!image) return;
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src = src;
      image.alt = title || '';
      card.querySelector('[data-product-placeholder]')?.remove();
    };

    const rebuildVariants = (card, product) => {
      const select = card.querySelector('[data-variant-select]');
      const single = card.querySelector('[data-single-variant]');
      const field = card.querySelector('[data-variant-field]');
      if (!select || !single || !product?.variants?.length) return;
      const firstAvailable = product.variants.find((variant) => variant.available) || product.variants[0];

      select.innerHTML = '';
      product.variants.forEach((variant) => {
        const option = document.createElement('option');
        option.value = variant.id;
        option.textContent = `${variant.title}${variant.available ? '' : ' — Esgotado'}`;
        option.disabled = !variant.available;
        option.selected = variant.id === firstAvailable.id;
        option.dataset.title = variant.title;
        option.dataset.price = variant.price;
        option.dataset.compare = variant.compare || 0;
        option.dataset.image = variant.image || product.image || '';
        option.dataset.available = String(Boolean(variant.available));
        select.appendChild(option);
      });

      const onlyOne = product.variants.length === 1;
      if (field) field.hidden = onlyOne;
      select.hidden = onlyOne;
      select.disabled = onlyOne;
      single.disabled = !onlyOne;
      single.value = firstAvailable.id;
      single.dataset.title = firstAvailable.title;
      single.dataset.price = firstAvailable.price;
      single.dataset.compare = firstAvailable.compare || 0;
      single.dataset.image = firstAvailable.image || product.image || '';
      single.dataset.available = String(Boolean(firstAvailable.available));
    };

    const updateCard = (root, card) => {
      const variant = getVariant(card);
      if (!variant) return;
      const price = displayPrice(card, variant);
      const compare = displayCompare(card, variant);
      const priceElement = card.querySelector('[data-card-price]');
      const compareElement = card.querySelector('[data-card-compare]');
      const compareLine = card.querySelector('[data-compare-line]');
      if (priceElement) priceElement.textContent = formatMoney(price);
      if (compareElement) compareElement.textContent = formatMoney(compare);
      if (compareLine) compareLine.hidden = !(compare > price);
      card.classList.toggle('is-unavailable', !variant.available);
      setImage(card, variant.image, card.dataset.activeProductTitle);

      const panel = card.closest('[data-step-panel]');
      const panelStep = Number(panel?.dataset.stepPanel) || 0;
      const next = panel?.querySelector('[data-step-next]');
      if (next) next.disabled = !variant.available;
      if (!variant.available && panelStep) {
        root._bundleCompleted?.delete(panelStep);
        panel?.classList.remove('is-complete');
        root.querySelector(`[data-step-indicator="${panelStep}"]`)?.classList.remove('is-complete');
      }
      updateSummary(root);
    };

    const selectProduct = (root, card, choice) => {
      const product = parseProduct(choice.dataset.jsonId);
      if (!product) return;
      card.querySelectorAll('[data-product-choice]').forEach((button) => {
        const active = button === choice;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });

      card.dataset.activeProductId = product.id;
      card.dataset.activeProductTitle = product.title;
      const name = card.querySelector('[data-product-name]');
      if (name && card.dataset.fixedTitle !== 'true') name.textContent = product.title;
      const currentChoice = card.querySelector('[data-current-choice-label]');
      if (currentChoice) currentChoice.textContent = choice.dataset.choiceLabel || product.title;
      rebuildVariants(card, product);
      setImage(card, product.image, product.title);
      updateCard(root, card);
    };

    const cardSelection = (card) => {
      const variant = getVariant(card);
      if (!variant) return null;
      const quantityInput = card.querySelector('[data-quantity-input]');
      const quantity = Math.max(1, Number(quantityInput?.value) || Number(card.dataset.quantity) || 1);
      return {
        card,
        id: variant.id,
        variantTitle: variant.title,
        available: variant.available,
        productId: card.dataset.activeProductId,
        productTitle: card.dataset.activeProductTitle,
        choiceLabel: card.querySelector('[data-current-choice-label]')?.textContent.trim() || '',
        image: variant.image,
        quantity,
        price: displayPrice(card, variant),
        compare: displayCompare(card, variant)
      };
    };

    const allSelections = (root) => Array.from(root.querySelectorAll('[data-bundle-card]')).map(cardSelection).filter(Boolean);

    const installmentText = (root, total) => {
      const count = Math.max(1, Number(root.dataset.installmentsCount) || 1);
      const template = root.dataset.installmentsTemplate || 'Em até [count]x de [value] sem juros';
      return template.replace('[count]', count).replace('[value]', formatMoney(total / count));
    };

    const updateSummary = (root) => {
      const selections = allSelections(root);
      const container = root.querySelector('[data-summary-items]');
      if (container) {
        container.innerHTML = selections.map((selection, index) => {
          const panel = selection.card.closest('[data-step-panel]');
          const label = selection.card.dataset.summaryLabel || `Item ${index + 1}`;
          const metaParts = [];
          if (selection.choiceLabel) metaParts.push(selection.choiceLabel);
          if (selection.variantTitle && selection.variantTitle !== 'Default Title') metaParts.push(selection.variantTitle);
          if (selection.quantity > 1) metaParts.push(`Qtd. ${selection.quantity}`);
          return `
            <article class="ivory-bundle__summary-item" data-summary-step="${panel?.dataset.stepPanel || index + 1}">
              <div class="ivory-bundle__summary-thumb">${selection.image ? `<img src="${escapeHtml(selection.image)}" alt="" width="96" height="114" loading="lazy">` : ''}</div>
              <div class="ivory-bundle__summary-info">
                <span class="ivory-bundle__summary-label">${escapeHtml(label)}</span>
                <span class="ivory-bundle__summary-title">${escapeHtml(selection.productTitle)}</span>
                <span class="ivory-bundle__summary-meta">${escapeHtml(metaParts.join(' · '))}</span>
              </div>
              <strong class="ivory-bundle__summary-price">${formatMoney(selection.price * selection.quantity)}</strong>
            </article>
          `;
        }).join('');
      }

      const total = selections.reduce((sum, selection) => sum + selection.price * selection.quantity, 0);
      const compare = selections.reduce((sum, selection) => {
        const effectiveCompare = selection.compare > selection.price ? selection.compare : selection.price;
        return sum + effectiveCompare * selection.quantity;
      }, 0);
      const totalPrice = root.querySelector('[data-total-price]');
      const totalCompare = root.querySelector('[data-total-compare]');
      const savingsBadge = root.querySelector('[data-savings-badge]');
      const installments = root.querySelector('[data-total-installments]');
      if (totalPrice) totalPrice.textContent = formatMoney(total);
      if (totalCompare) {
        totalCompare.textContent = formatMoney(compare);
        totalCompare.hidden = !(compare > total);
      }
      if (savingsBadge) {
        savingsBadge.hidden = !(compare > total);
        const value = savingsBadge.querySelector('span');
        if (value) value.textContent = formatMoney(compare - total);
      }
      if (installments) installments.textContent = total ? installmentText(root, total) : '';
    };

    const showStep = (root, targetStep, unlock = false) => {
      const maxStep = Number(root.dataset.reviewStep) || 1;
      const step = Math.min(maxStep, Math.max(1, Number(targetStep) || 1));
      if (unlock) root._bundleUnlocked = Math.max(root._bundleUnlocked || 1, step);

      root.querySelectorAll('[data-step-panel]').forEach((panel) => {
        const active = Number(panel.dataset.stepPanel) === step;
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
      });
      root.querySelectorAll('[data-step-indicator]').forEach((indicator) => {
        const indicatorStep = Number(indicator.dataset.stepIndicator);
        const active = indicatorStep === step;
        const complete = root._bundleCompleted?.has(indicatorStep) || false;
        const unlocked = indicatorStep <= (root._bundleUnlocked || 1);
        indicator.classList.toggle('is-active', active);
        indicator.classList.toggle('is-complete', complete && !active);
        indicator.classList.toggle('is-unlocked', unlocked);
        indicator.setAttribute('aria-selected', String(active));
        indicator.setAttribute('aria-disabled', String(!unlocked));
        if (active) {
          const progress = indicator.parentElement;
          if (progress && progress.scrollWidth > progress.clientWidth) {
            const left = indicator.offsetLeft - (progress.clientWidth - indicator.offsetWidth) / 2;
            progress.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
          }
        }
      });
      root._bundleActiveStep = step;
      if (step === maxStep) updateSummary(root);
    };

    const advance = (root, targetStep) => {
      const currentStep = root._bundleActiveStep || 1;
      const panel = root.querySelector(`[data-step-panel="${currentStep}"]`);
      const card = panel?.querySelector('[data-bundle-card]');
      const selection = card ? cardSelection(card) : null;
      if (!selection?.available) {
        setStatus(root, root.dataset.emptyMessage, true);
        card?.classList.add('is-unavailable');
        return;
      }
      root._bundleCompleted.add(currentStep);
      panel?.classList.add('is-complete');
      setStatus(root, '');
      showStep(root, targetStep, true);
    };

    const setStatus = (root, message, error = false) => {
      const status = root.querySelector('[data-bundle-status]');
      if (!status) return;
      status.textContent = message || '';
      status.classList.toggle('is-error', error);
    };

    const updateCartCount = async () => {
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' } });
        if (!response.ok) return;
        const cart = await response.json();
        document.querySelectorAll('[data-cart-count], .cart-count-bubble span[aria-hidden="true"]').forEach((element) => {
          element.textContent = cart.item_count;
          element.hidden = false;
        });
        document.dispatchEvent(new CustomEvent('ivory:cart-updated', { detail: { cart } }));
      } catch (error) {
        /* Progressive enhancement only. */
      }
    };

    const openCartDrawer = () => {
      const trigger = document.querySelector([
        '[data-testid="cart-drawer-trigger"]',
        '[data-cart-drawer-trigger]',
        '#cart-icon-bubble',
        '.header__icon--cart',
        'button[aria-controls*="cart" i]',
        'a[aria-controls*="cart" i]'
      ].join(', '));
      if (trigger) {
        trigger.click();
        return;
      }
      const drawer = document.querySelector('[data-cart-drawer], cart-drawer');
      if (!drawer) return;
      if (typeof drawer.open === 'function') drawer.open();
      drawer.classList.add('is-open', 'active');
      drawer.setAttribute('aria-hidden', 'false');
      document.querySelector('[data-drawer-overlay]')?.classList.add('is-visible');
    };

    const mountAtAnchor = (root, attempt = 0) => {
      if (root.dataset.anchorMounted === 'true') return;
      const anchor = document.getElementById(root.dataset.anchorId || 'ancora-combos');
      const sectionWrapper = root.closest('.shopify-section') || root;

      if (anchor && sectionWrapper && !sectionWrapper.contains(anchor)) {
        if (sectionWrapper.parentElement !== anchor) anchor.appendChild(sectionWrapper);
        root.dataset.anchorMounted = 'true';
        return;
      }

      if (!anchor && attempt < 20) {
        window.setTimeout(() => mountAtAnchor(root, attempt + 1), 150);
      }
    };

    const addBundle = async (root) => {
      const selections = allSelections(root);
      const expected = Number(root.dataset.itemsCount) || 0;
      const invalidIndex = selections.findIndex((selection) => !selection.available);
      if (selections.length !== expected || invalidIndex >= 0) {
        const target = invalidIndex >= 0 ? invalidIndex + 1 : 1;
        setStatus(root, root.dataset.emptyMessage, true);
        showStep(root, target, true);
        return;
      }

      const button = root.querySelector('[data-add-bundle]');
      const label = button?.textContent;
      if (button) {
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        button.textContent = 'Adicionando…';
      }
      setStatus(root, '');

      try {
        const response = await fetch(window.routes?.cart_add_url || `${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: selections.map((selection, index) => ({
              id: selection.id,
              quantity: selection.quantity,
              properties: {
                _combo_id: root.dataset.sectionId,
                _combo: root.dataset.comboTitle,
                _item_do_combo: index + 1
              }
            })),
            sections: ['cart-drawer', 'cart-icon-bubble'],
            sections_url: window.location.pathname
          })
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || root.dataset.cartError);
        const cartDrawer = document.querySelector('cart-drawer');
        if (result.sections && cartDrawer && typeof cartDrawer.renderContents === 'function') {
          cartDrawer.renderContents(result);
        }
        setStatus(root, root.dataset.cartSuccess);
        await updateCartCount();
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { source: 'ivory-bundle' } }));
        openCartDrawer();
      } catch (error) {
        setStatus(root, error.message || root.dataset.cartError, true);
      } finally {
        if (button) {
          button.disabled = false;
          button.removeAttribute('aria-busy');
          button.textContent = label;
        }
      }
    };

    const bind = (root) => {
      if (root.dataset.bundleBound === 'true') return;
      root.dataset.bundleBound = 'true';
      mountAtAnchor(root);
      root._bundleActiveStep = 1;
      root._bundleUnlocked = 1;
      root._bundleCompleted = new Set();

      root.querySelectorAll('[data-bundle-card]').forEach((card) => {
        const activeChoice = card.querySelector('[data-product-choice].is-active') || card.querySelector('[data-product-choice]');
        if (activeChoice) selectProduct(root, card, activeChoice);
        else updateCard(root, card);
      });
      updateSummary(root);

      root.addEventListener('click', (event) => {
        const choice = event.target.closest('[data-product-choice]');
        if (choice && root.contains(choice)) {
          selectProduct(root, choice.closest('[data-bundle-card]'), choice);
          return;
        }

        const quantityButton = event.target.closest('[data-quantity-change]');
        if (quantityButton && root.contains(quantityButton)) {
          const input = quantityButton.parentElement.querySelector('[data-quantity-input]');
          const next = Math.min(Number(input.max) || 99, Math.max(Number(input.min) || 1, (Number(input.value) || 1) + Number(quantityButton.dataset.quantityChange)));
          input.value = next;
          input.dispatchEvent(new Event('change', { bubbles: true }));
          return;
        }

        const next = event.target.closest('[data-step-next]');
        if (next && root.contains(next)) {
          advance(root, next.dataset.stepNext);
          return;
        }

        const back = event.target.closest('[data-step-back]');
        if (back && root.contains(back)) {
          showStep(root, back.dataset.stepBack, true);
          return;
        }

        const indicator = event.target.closest('[data-step-indicator]');
        if (indicator && root.contains(indicator) && indicator.classList.contains('is-unlocked')) {
          showStep(root, indicator.dataset.stepIndicator);
          return;
        }

        if (event.target.closest('[data-add-bundle]')) addBundle(root);
      });

      root.addEventListener('change', (event) => {
        const card = event.target.closest('[data-bundle-card]');
        if (!card) return;
        if (event.target.matches('[data-quantity-input]')) {
          event.target.value = Math.min(Number(event.target.max) || 99, Math.max(Number(event.target.min) || 1, Number(event.target.value) || 1));
        }
        if (event.target.matches('[data-variant-select], [data-quantity-input]')) updateCard(root, card);
      });

      showStep(root, 1);
    };

    const init = (scope = document) => scope.querySelectorAll(ROOT_SELECTOR).forEach(bind);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
    else init();
    document.addEventListener('shopify:section:load', (event) => init(event.target));
    document.addEventListener('shopify:block:select', (event) => {
      const root = event.target.closest(ROOT_SELECTOR);
      if (!root) return;
      const panel = root.querySelector(`[data-block-id="${event.detail.blockId}"]`);
      if (panel) showStep(root, panel.dataset.stepPanel, true);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["social-grid"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-social-gallery]';

    const getPositions = (root) => {
      const viewport = root.querySelector('[data-social-viewport]');
      const items = Array.from(root.querySelectorAll('.social-gallery__item'));
      if (!viewport || !items.length) return [];
      const maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
      if (maxScroll <= 2) return [0];
      const firstOffset = items[0].offsetLeft;
      const positions = [];
      items.forEach((item) => {
        const position = Math.min(maxScroll, Math.max(0, item.offsetLeft - firstOffset));
        if (!positions.some((current) => Math.abs(current - position) <= 2)) positions.push(position);
      });
      if (!positions.some((current) => Math.abs(current - maxScroll) <= 2)) positions.push(maxScroll);
      return positions.sort((a, b) => a - b);
    };

    const updateDots = (root) => {
      const viewport = root.querySelector('[data-social-viewport]');
      const container = root.querySelector('[data-social-dots]');
      if (!viewport || !container) return;
      const positions = getPositions(root);
      const key = positions.map((position) => Math.round(position)).join(',');
      if (container.dataset.positionKey !== key) {
        const fragment = document.createDocumentFragment();
        positions.forEach((position, index) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'social-gallery__dot';
          dot.dataset.socialDot = String(index);
          dot.setAttribute('aria-label', `Ir para posição ${index + 1}`);
          fragment.appendChild(dot);
        });
        container.replaceChildren(fragment);
        container.dataset.positionKey = key;
        container.dataset.positions = JSON.stringify(positions);
      }
      container.classList.toggle('is-inactive', positions.length <= 1);
      let activeIndex = 0;
      let shortest = Infinity;
      positions.forEach((position, index) => {
        const distance = Math.abs(viewport.scrollLeft - position);
        if (distance < shortest) {
          shortest = distance;
          activeIndex = index;
        }
      });
      container.querySelectorAll('[data-social-dot]').forEach((dot, index) => {
        const active = index === activeIndex;
        dot.classList.toggle('is-active', active);
        if (active) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    };

    const update = (root) => {
      const viewport = root.querySelector('[data-social-viewport]');
      if (!viewport) return;
      const maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth - 2);
      const previous = root.querySelector('[data-social-direction="prev"]');
      const next = root.querySelector('[data-social-direction="next"]');
      if (previous) previous.disabled = viewport.scrollLeft <= 2;
      if (next) next.disabled = viewport.scrollLeft >= maxScroll;
      updateDots(root);
    };

    const scroll = (root, direction) => {
      const viewport = root.querySelector('[data-social-viewport]');
      const items = Array.from(root.querySelectorAll('.social-gallery__item'));
      if (!viewport || !items.length) return;
      let distance = viewport.clientWidth * .8;
      if (items.length > 1) distance = Math.abs(items[1].offsetLeft - items[0].offsetLeft);
      viewport.scrollBy({ left: direction === 'next' ? distance : -distance, behavior: 'smooth' });
    };

    const bind = (root) => {
      if (!root || root.dataset.socialBound === 'true') return;
      root.dataset.socialBound = 'true';
      const viewport = root.querySelector('[data-social-viewport]');

      root.addEventListener('click', (event) => {
        const dot = event.target.closest('[data-social-dot]');
        if (dot && root.contains(dot) && viewport) {
          const container = dot.closest('[data-social-dots]');
          const positions = JSON.parse(container.dataset.positions || '[]');
          const position = positions[Number(dot.dataset.socialDot)];
          if (Number.isFinite(position)) viewport.scrollTo({ left: position, behavior: 'smooth' });
          return;
        }
        const arrow = event.target.closest('[data-social-direction]');
        if (!arrow || !root.contains(arrow)) return;
        scroll(root, arrow.dataset.socialDirection);
      });

      if (viewport) {
        let scheduled = false;
        viewport.addEventListener('scroll', () => {
          if (scheduled) return;
          scheduled = true;
          requestAnimationFrame(() => {
            update(root);
            scheduled = false;
          });
        }, { passive: true });
        if ('ResizeObserver' in window) {
          const observer = new ResizeObserver(() => update(root));
          observer.observe(viewport);
        }
      }
      update(root);
    };

    const init = (scope = document) => scope.querySelectorAll(selector).forEach(bind);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
    else init();
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
